// OSIS GROUP FLOOR SRL - Pardoseli Industriale - Mock Data
// CUI 41296575 - Generat pentru compania OSIS GROUP FLOOR SRL specializată în pardoseli industriale

// Echipa OSIS GROUP FLOOR SRL (14 angajați)
const osisEmployees = [
  {
    id: 1,
    name: 'Botezatu Daniel',
    position: 'Betonist',
    department: 'Execuție',
    email: 'daniel.botezatu@osisgroup.ro',
    phone: '+40 721 001 001',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2021-03-15',
    salary: '3500 RON',
    avatar: '/avatars/daniel-b.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Elicopterizare', 'Nivelare'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 2,
    name: 'Cojocaru Constantin',
    position: 'Manager Tehnic',
    department: 'Management',
    email: 'constantin.cojocaru@osisgroup.ro',
    phone: '+40 721 002 002',
    specialization: 'Coordonare tehnică proiecte, supervizare execuție',
    status: 'Activ',
    startDate: '2020-01-10',
    salary: '5500 RON',
    avatar: '/avatars/constantin.jpg',
    skills: ['Management Tehnic', 'Coordonare Proiecte', 'Control Calitate', 'Planificare'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: '08:00-12:00',
      sunday: 'Liber'
    }
  },
  {
    id: 3,
    name: 'Cojocaru Nicoleta',
    position: 'Manager HR',
    department: 'Resurse Umane',
    email: 'nicoleta.cojocaru@osisgroup.ro',
    phone: '+40 721 003 003',
    specialization: 'Resurse umane, administrație personal',
    status: 'Activ',
    startDate: '2020-02-01',
    salary: '4200 RON',
    avatar: '/avatars/nicoleta.jpg',
    skills: ['Resurse Umane', 'Recrutare', 'Administrare Personal', 'Legislația Muncii'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 4,
    name: 'Vieru Ionuț-Laurențiu',
    position: 'Betonist',
    department: 'Execuție',
    email: 'ionut.vieru@osisgroup.ro',
    phone: '+40 721 004 004',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2021-05-20',
    salary: '3500 RON',
    avatar: '/avatars/ionut-v.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Șlefuire', 'Control Calitate'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 5,
    name: 'Țingăială Vlad',
    position: 'Inginer',
    department: 'Tehnică',
    email: 'vlad.tingaiala@osisgroup.ro',
    phone: '+40 721 005 005',
    specialization: 'Proiectare tehnică, calcule structurale',
    status: 'Activ',
    startDate: '2020-06-01',
    salary: '4800 RON',
    avatar: '/avatars/vlad.jpg',
    skills: ['Proiectare CAD', 'Calcule Structurale', 'Evaluare Suprafețe', 'AutoCAD'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 6,
    name: 'Țingăială Irina',
    position: 'Secretară',
    department: 'Administrație',
    email: 'irina.tingaiala@osisgroup.ro',
    phone: '+40 721 006 006',
    specialization: 'Administrație, documente, corespondență',
    status: 'Activ',
    startDate: '2020-07-15',
    salary: '3200 RON',
    avatar: '/avatars/irina.jpg',
    skills: ['Administrare Documente', 'Corespondență', 'Organizare', 'Comunicare'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 7,
    name: 'Popa Gheorghiță',
    position: 'Șef Echipă',
    department: 'Execuție',
    email: 'gheorghita.popa@osisgroup.ro',
    phone: '+40 721 007 007',
    specialization: 'Coordonare echipă execuție, supervizare lucrări',
    status: 'Activ',
    startDate: '2019-11-01',
    salary: '4500 RON',
    avatar: '/avatars/gheorghita.jpg',
    skills: ['Coordonare Echipă', 'Supervizare Lucrări', 'Pardoseli Industriale', 'Control Calitate'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: '08:00-12:00',
      sunday: 'Liber'
    }
  },
  {
    id: 8,
    name: 'Tuțueanu Marin Mădălin',
    position: 'Betonist',
    department: 'Execuție',
    email: 'madalin.tutueanu@osisgroup.ro',
    phone: '+40 721 008 008',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2021-08-10',
    salary: '3500 RON',
    avatar: '/avatars/madalin.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Elicopterizare', 'Pregătire Suprafețe'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 9,
    name: 'Schirliu Adrian',
    position: 'Betonist',
    department: 'Execuție',
    email: 'adrian.schirliu@osisgroup.ro',
    phone: '+40 721 009 009',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2022-01-15',
    salary: '3500 RON',
    avatar: '/avatars/adrian.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Nivelare', 'Control Calitate'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 10,
    name: 'Teleucă Daniel',
    position: 'Betonist',
    department: 'Execuție',
    email: 'daniel.teleuca@osisgroup.ro',
    phone: '+40 721 010 010',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2021-09-01',
    salary: '3500 RON',
    avatar: '/avatars/daniel-t.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Elicopterizare', 'Șlefuire'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 11,
    name: 'Vieru Gheorghe',
    position: 'Betonist',
    department: 'Execuție',
    email: 'gheorghe.vieru@osisgroup.ro',
    phone: '+40 721 011 011',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2020-04-20',
    salary: '3500 RON',
    avatar: '/avatars/gheorghe.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Pregătire Suprafețe', 'Control Calitate'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 12,
    name: 'Teleucă Ionuț-Petronel',
    position: 'Betonist',
    department: 'Execuție',
    email: 'ionut.teleuca@osisgroup.ro',
    phone: '+40 721 012 012',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2022-03-10',
    salary: '3500 RON',
    avatar: '/avatars/ionut-t.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Nivelare', 'Elicopterizare'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 13,
    name: 'Țingăială Marius',
    position: 'Betonist',
    department: 'Execuție',
    email: 'marius.tingaiala@osisgroup.ro',
    phone: '+40 721 013 013',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2021-11-15',
    salary: '3500 RON',
    avatar: '/avatars/marius.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Șlefuire', 'Pregătire Suprafețe'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 14,
    name: 'Teleucă Răzvan',
    position: 'Betonist',
    department: 'Execuție',
    email: 'razvan.teleuca@osisgroup.ro',
    phone: '+40 721 014 014',
    specialization: 'Turnare și finisare beton, pardoseli industriale',
    status: 'Activ',
    startDate: '2022-05-01',
    salary: '3500 RON',
    avatar: '/avatars/razvan.jpg',
    skills: ['Turnare Beton', 'Finisare Pardoseli', 'Control Calitate', 'Nivelare'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  }
];

export const mockData = {
  // Angajați OSIS (11 persoane)
  employees: osisEmployees,

  // Concedii pentru echipa OSIS
  vacations: [
    { id: 1, employee: 'Aostăcioaei Dumitru - Ciprian', startDate: '2024-08-01', endDate: '2024-08-15', days: 14, status: 'Planificat', type: 'Concediu de odihnă', requestDate: '2024-03-15', approvedBy: 'Auto-aprobat', reason: 'Concediu de vară' },
    { id: 2, employee: 'Bărbosu Mihăiță - Daniel', startDate: '2024-07-20', endDate: '2024-07-27', days: 7, status: 'Aprobat', type: 'Concediu de odihnă', requestDate: '2024-03-10', approvedBy: 'Ciprian Aostăcioaei', reason: 'Concediu planificat' },
    { id: 3, employee: 'Moroșan Noemia', startDate: '2024-01-15', endDate: '2025-01-15', days: 365, status: 'În curs', type: 'Concediu creștere copil', requestDate: '2023-12-01', approvedBy: 'Ciprian Aostăcioaei', reason: 'Concediu maternal' }
  ],

  // Clienți OSIS - Industria pardoselilor industriale
  customers: [
    {
      id: 1,
      name: 'SC Logistic Center SRL',
      type: 'B2B',
      contactPerson: 'Ing. Popescu Marius',
      email: 'office@logisticcenter.ro',
      phone: '+40 721 123 456',
      status: 'Client fidel',
      lastContact: '2024-03-14',
      orders: 15,
      totalSpent: '145,600 RON',
      projects: ['Hală Logistică 5000mp', 'Parcare Acoperită 2000mp'],
      tier: 'VIP',
      source: 'Recomandare',
      address: 'Str. Industriei 45, București',
      notes: 'Client B2B important, comenzi regulate pentru hale logistice'
    },
    {
      id: 2,
      name: 'Fabrica Auto Parts SRL',
      type: 'B2B',
      contactPerson: 'Director Ionescu Mihai',
      email: 'mihai.ionescu@autoparts.ro',
      phone: '+40 731 234 567',
      status: 'Client nou',
      lastContact: '2024-03-12',
      orders: 1,
      totalSpent: '78,200 RON',
      projects: ['Hală Producție 3500mp'],
      tier: 'Regular',
      source: 'Google Search',
      address: 'Bd. Industriilor 15, Pitești',
      notes: 'Prima comandă, pardoseală epoxidică pentru hală producție'
    },
    {
      id: 3,
      name: 'Hypermarket Fresh SRL',
      type: 'B2B',
      contactPerson: 'Gheorghe Marinescu',
      email: 'tehnic@hypermarketfresh.ro',
      phone: '+40 741 234 567',
      status: 'Prospect',
      lastContact: '2024-03-10',
      orders: 0,
      totalSpent: '0 RON',
      projects: ['Renovare Supermarket 4000mp'],
      tier: 'Prospect',
      source: 'Licitație',
      address: 'Str. Comercială 22, Constanța',
      notes: 'Interesați de pardoseală antistatică pentru zona alimentară'
    },
    {
      id: 4,
      name: 'SC Pharma Distribution SRL',
      type: 'B2B',
      contactPerson: 'Elena Vasilescu',
      email: 'elena.vasilescu@pharmadist.ro',
      phone: '+40 751 234 567',
      status: 'Client fidel',
      lastContact: '2024-03-15',
      orders: 8,
      totalSpent: '234,900 RON',
      projects: ['Depozit Frigorific 2500mp', 'Cameră Curată 500mp'],
      tier: 'Premium',
      source: 'Recomandare',
      address: 'Str. Farmaciei 12, București',
      notes: 'Clienți fideli, proiecte farmaceutice cu cerințe speciale'
    },
    {
      id: 5,
      name: 'Service Auto Elite SRL',
      type: 'B2B',
      contactPerson: 'Adrian Munteanu',
      email: 'office@serviceelite.ro',
      phone: '+40 761 234 567',
      status: 'Client activ',
      lastContact: '2024-03-08',
      orders: 3,
      totalSpent: '45,800 RON',
      projects: ['Service Auto 800mp', 'Showroom 400mp'],
      tier: 'Regular',
      source: 'Facebook',
      address: 'Calea Victoriei 156, București',
      notes: 'Service auto premium, pardoseli antiderapante și estetice'
    }
  ],

  // Servicii OSIS - Pardoseli Industriale
  products: [
    {
      id: 1,
      name: 'Pardoseală Epoxidică Standard',
      category: 'Pardoseli Epoxidice',
      unit: 'mp',
      price: '45 RON/mp',
      description: 'Sistem epoxidic bicomponent, rezistent la trafic intens, ideal pentru hale industriale',
      inStock: true,
      estimatedTime: '3-5 zile',
      specifications: {
        grosime: '2-3 mm',
        rezistenta: 'Trafic greu',
        finisaj: 'Mat sau lucios',
        durabilitate: '10+ ani'
      }
    },
    {
      id: 2,
      name: 'Pardoseală Epoxidică Autonivelantă',
      category: 'Pardoseli Epoxidice',
      unit: 'mp',
      price: '65 RON/mp',
      description: 'Sistem autonivelant pentru suprafețe perfecte, rezistență chimică ridicată',
      inStock: true,
      estimatedTime: '4-6 zile',
      specifications: {
        grosime: '3-5 mm',
        rezistenta: 'Chimică și mecanică',
        finisaj: 'Lucios oglindă',
        durabilitate: '15+ ani'
      }
    },
    {
      id: 3,
      name: 'Pardoseală Poliuretanică',
      category: 'Pardoseli Poliuretanice',
      unit: 'mp',
      price: '75 RON/mp',
      description: 'Sistem poliuretanic flexibil, rezistent la variații termice și UV',
      inStock: true,
      estimatedTime: '5-7 zile',
      specifications: {
        grosime: '2-4 mm',
        rezistenta: 'Termică -40°C până +80°C',
        finisaj: 'Satinat',
        durabilitate: '12+ ani'
      }
    },
    {
      id: 4,
      name: 'Beton Șlefuit Decorativ',
      category: 'Beton Șlefuit',
      unit: 'mp',
      price: '55 RON/mp',
      description: 'Șlefuire și lustruire beton existent, aspect modern industrial',
      inStock: true,
      estimatedTime: '2-4 zile',
      specifications: {
        nivelSlefuire: '400-3000 grit',
        tratament: 'Densificator și sigilant',
        finisaj: 'Mat, satinat sau lucios',
        durabilitate: '20+ ani'
      }
    },
    {
      id: 5,
      name: 'Pardoseală Antistatică ESD',
      category: 'Pardoseli Speciale',
      unit: 'mp',
      price: '95 RON/mp',
      description: 'Sistem antistat pentru electronice, farmaceutice și camere curate',
      inStock: true,
      estimatedTime: '5-8 zile',
      specifications: {
        rezistentaElectrica: '< 10⁶ Ω',
        standard: 'IEC 61340-5-1',
        finisaj: 'Mat uniform',
        durabilitate: '10+ ani'
      }
    },
    {
      id: 6,
      name: 'Pardoseală Industrială Heavy Duty',
      category: 'Pardoseli Industriale',
      unit: 'mp',
      price: '85 RON/mp',
      description: 'Sistem ultra-rezistent pentru trafic extrem de greu și impacturi',
      inStock: true,
      estimatedTime: '5-7 zile',
      specifications: {
        grosime: '6-9 mm',
        rezistenta: 'Motostivuitoare 10+ tone',
        finisaj: 'Antiderapant',
        durabilitate: '15+ ani'
      }
    },
    {
      id: 7,
      name: 'Reparații Pardoseli Existente',
      category: 'Servicii Reparații',
      unit: 'mp',
      price: '35 RON/mp',
      description: 'Reparare fisuri, găuri și zone deteriorate în pardoseli existente',
      inStock: true,
      estimatedTime: '1-3 zile',
      specifications: {
        tipReparatie: 'Locală sau extinsă',
        materiale: 'Mortare epoxidice',
        finisaj: 'Compatibil cu existentul',
        garantie: '5 ani'
      }
    },
    {
      id: 8,
      name: 'Marcaje și Delimitări Industriale',
      category: 'Servicii Complementare',
      unit: 'ml',
      price: '15 RON/ml',
      description: 'Marcaje de siguranță, zone de circulație, delimitări conform normelor',
      inStock: true,
      estimatedTime: '1-2 zile',
      specifications: {
        latimeBanda: '5-15 cm',
        culori: 'Standard RAL',
        rezistenta: 'Trafic intens',
        durabilitate: '5+ ani'
      }
    }
  ],

  // Comenzi și proiecte active
  sales: [
    { id: 1, product: 'Pardoseală Epoxidică Standard', quantity: 2500, amount: '112,500 RON', date: '2024-03-15', client: 'SC Logistic Center SRL', category: 'Pardoseli Epoxidice', unit: 'mp' },
    { id: 2, product: 'Beton Șlefuit Decorativ', quantity: 800, amount: '44,000 RON', date: '2024-03-14', client: 'Service Auto Elite SRL', category: 'Beton Șlefuit', unit: 'mp' },
    { id: 3, product: 'Pardoseală Antistatică ESD', quantity: 500, amount: '47,500 RON', date: '2024-03-13', client: 'SC Pharma Distribution SRL', category: 'Pardoseli Speciale', unit: 'mp' },
    { id: 4, product: 'Pardoseală Epoxidică Autonivelantă', quantity: 3500, amount: '227,500 RON', date: '2024-03-12', client: 'Fabrica Auto Parts SRL', category: 'Pardoseli Epoxidice', unit: 'mp' },
    { id: 5, product: 'Marcaje și Delimitări Industriale', quantity: 450, amount: '6,750 RON', date: '2024-03-11', client: 'SC Logistic Center SRL', category: 'Servicii Complementare', unit: 'ml' }
  ],

  // Inventar materiale și echipamente
  inventory: [
    { id: 1, product: 'Rășină Epoxidică Bicomponent (kg)', quantity: 850, minStock: 300, status: 'În stoc', location: 'Depozit materiale', category: 'Rășini', price: '35 RON/kg' },
    { id: 2, product: 'Rășină Poliuretanică (kg)', quantity: 120, minStock: 150, status: 'Stoc redus', location: 'Depozit materiale', category: 'Rășini', price: '48 RON/kg' },
    { id: 3, product: 'Cuarț Colorat (kg)', quantity: 1200, minStock: 500, status: 'În stoc', location: 'Depozit agregate', category: 'Agregate', price: '8 RON/kg' },
    { id: 4, product: 'Primer Epoxidic (kg)', quantity: 280, minStock: 100, status: 'În stoc', location: 'Depozit materiale', category: 'Primeri', price: '42 RON/kg' },
    { id: 5, product: 'Discuri Diamantate 250mm (buc)', quantity: 8, minStock: 15, status: 'Stoc critic', location: 'Magazie utilaje', category: 'Consumabile', price: '450 RON/buc' },
    { id: 6, product: 'Densificator Beton (litri)', quantity: 180, minStock: 80, status: 'În stoc', location: 'Depozit chimicale', category: 'Tratamente', price: '25 RON/litru' },
    { id: 7, product: 'Mortar Reparații Rapid (kg)', quantity: 350, minStock: 200, status: 'În stoc', location: 'Depozit materiale', category: 'Mortare', price: '15 RON/kg' },
    { id: 8, product: 'Vopsea Marcaj Industrială (litri)', quantity: 45, minStock: 30, status: 'În stoc', location: 'Depozit vopsele', category: 'Vopsele', price: '85 RON/litru' }
  ],

  // Facturi clienți
  invoices: [
    { id: 'OSIS-001', client: 'SC Logistic Center SRL', amount: '112,500.00 RON', status: 'Plătită', date: '2024-03-15', description: 'Pardoseală epoxidică hală 2500mp' },
    { id: 'OSIS-002', client: 'Fabrica Auto Parts SRL', amount: '78,200.00 RON', status: 'În așteptare', date: '2024-03-14', description: 'Avans pardoseală hală producție' },
    { id: 'OSIS-003', client: 'SC Pharma Distribution SRL', amount: '47,500.00 RON', status: 'Plătită', date: '2024-03-13', description: 'Pardoseală antistatică cameră curată' },
    { id: 'OSIS-004', client: 'Service Auto Elite SRL', amount: '44,000.00 RON', status: 'Expirată', date: '2024-03-05', description: 'Beton șlefuit showroom și service' }
  ],

  // Campanii marketing
  campaigns: [
    { id: 1, name: 'Pardoseli Industriale 2024', type: 'Google Ads', status: 'Activă', reach: '45,400', conversion: '8.5%', budget: '2500 RON', target: 'Manageri hale industriale' },
    { id: 2, name: 'Beton Șlefuit Showroom', type: 'Facebook Ads', status: 'Activă', reach: '25,800', conversion: '12.3%', budget: '1500 RON', target: 'Arhitecți și designeri' },
    { id: 3, name: 'Pardoseli Farmaceutice', type: 'LinkedIn', status: 'Planificată', reach: '8,200', conversion: '0%', budget: '1800 RON', target: 'Companii farmaceutice' },
    { id: 4, name: 'Renovări Hale Vechi', type: 'Email Marketing', status: 'În pregătire', reach: '12,500', conversion: '0%', budget: '600 RON', target: 'Proprietari hale industriale' }
  ],

  // Securitate și monitorizare
  threats: [
    { id: 1, type: 'Tentativă acces neautorizat', severity: 'Medie', ip: '192.168.1.150', timestamp: '2024-03-15 09:45', status: 'Investigat', description: 'Login eșuat pe sistemul de management proiecte' },
    { id: 2, type: 'Spam formular contact', severity: 'Scăzută', ip: '10.0.0.75', timestamp: '2024-03-15 14:20', status: 'Blocat automat', description: 'Mesaje spam pe site web' },
    { id: 3, type: 'Monitorizare echipamente', severity: 'Info', ip: 'Intern', timestamp: '2024-03-15 16:30', status: 'Normal', description: 'Verificare automată utilaje șlefuire' }
  ],

  // Analytics website
  analytics: [
    { metric: 'Vizitatori unici', value: '4,847', change: '+22%', period: 'Această lună' },
    { metric: 'Cereri ofertă', value: '89', change: '+18%', period: 'Această lună' },
    { metric: 'Rata de conversie', value: '6.8%', change: '+1.5%', period: 'Această lună' },
    { metric: 'Proiecte în lucru', value: '12', change: '+3', period: 'Această lună' }
  ],

  // Echipamente OSIS
  equipment: [
    { id: 1, name: 'Mașină Șlefuit Beton HTC 800', status: 'Disponibil', location: 'Depozit', lastService: '2024-02-15', nextService: '2024-05-15', utilizare: '1250 ore' },
    { id: 2, name: 'Aspirator Industrial Pullman', status: 'În folosință', location: 'Proiect Logistic Center', lastService: '2024-01-20', nextService: '2024-04-20', utilizare: '890 ore' },
    { id: 3, name: 'Freză Beton Blastrac BMG-435', status: 'Disponibil', location: 'Depozit', lastService: '2024-03-01', nextService: '2024-06-01', utilizare: '560 ore' },
    { id: 4, name: 'Pompă Injecție Rășină Graco', status: 'În folosință', location: 'Proiect Pharma', lastService: '2024-02-28', nextService: '2024-05-28', utilizare: '320 ore' }
  ]
};

// Helper functions pentru formatare
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON'
  }).format(amount);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('ro-RO');
};

export const getStatusColor = (status) => {
  const colors = {
    'Activ': 'success',
    'Activă': 'success',
    'Plătită': 'success',
    'Aprobat': 'success',
    'În stoc': 'success',
    'Normal': 'success',
    'Disponibil': 'success',
    'În așteptare': 'warning',
    'Planificată': 'warning',
    'Stoc redus': 'warning',
    'În progres': 'warning',
    'În folosință': 'warning',
    'Concediu': 'info',
    'Concediu maternal': 'info',
    'Monitorizat': 'info',
    'Prospect': 'info',
    'Info': 'info',
    'Expirată': 'error',
    'Stoc critic': 'error',
    'Investigat': 'error'
  };
  return colors[status] || 'default';
};

export const getDepartmentColor = (department) => {
  const colors = {
    'Management': 'primary',
    'Producție': 'secondary',
    'Administrație': 'accent-blue',
    'Tehnică': 'accent-wood',
    'Marketing': 'warning',
    'Logistică': 'info',
    'Montaj': 'success'
  };
  return colors[department] || 'gray';
};
